<template>
  <div class="field-checkbox">
    <check-box :id="id" :value="value" v-model="model" />
    <label :for="id">{{ label }}</label>
  </div>
</template>

<script>
import { ref, computed, watchEffect } from "vue";
import CheckBox from "primevue/checkbox";

export default {
  props: {
    modelValue: Array,
    name: String,
    value: [String, Number],
    label: String,
  },
  components: {
    CheckBox,
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const model = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit("update:modelValue", val);
      }
    });

    const id = ref(new Date().getTime().toString(16)  + Math.floor(1000*Math.random()).toString(16));
    watchEffect(() => {
      if (!props.name) return;
      id.value = props.name;
    });

    return { model, id };
  }
}
</script>